import { fetch } from './http'
/**
* 下面是获取数据的接口
*/
/**
* 测试接口
* 名称：exam
* 参数：paramObj/null
* 方式：fetch/post/patch/put
*/
export const api = {
  getNewsList: function (typeID) {
    return fetch('/newsList', { typeID: typeID })
  },
  getNewsContent: function (params) {
    return fetch('/newsContent', params)
  },
  getTopNewsList: function () {
    return fetch('/newsTopList')
  },
  getIndexNewsList: function () {
    return fetch('/newsIndexList')
  },
  getStrateIndexList: function (worldId) {
    return fetch('/strateIndexList', {worldId: worldId})
  },
  getStrateList: function (typeID) {
    return fetch('/strateList', { typeID: typeID })
  },
  getStrateContent: function (params) {
    return fetch('/strateContent', params)
  },
  getIntroIndexList: function (worldId) {
    return fetch('/introIndexList', {worldId: worldId})
  },
  getIntroList: function (typeID) {
    return fetch('/introList', { typeID: typeID })
  },
  getIntroContent: function (params) {
    return fetch('/introContent', params)
  },
  getBannerList: function () {
    return fetch('/banner')
  },
  getConfig: function (key) {
    return fetch('/config', { key: key })
  },
  getAllConfig: function () {
    return fetch('/allConfig')
  },
  getIndexPicList: function () {
    return fetch('/indexPicList')
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js